import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';
import { loading, handleErrorException, success } from 'State/actions';

export const getFiscalYears = () =>
  fetchGeneric(
    types.MEAL_EQUIVALENT_GET_FISCAL_YEARS,
    types.MEAL_EQUIVALENT_LOADING,
    types.MEAL_EQUIVALENT_ERRORS,
    'ControlInfo/FiscalYears'
  );

export const getGridData = fiscalYear => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_EQUIVALENT_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `SiteMaster/GetMealEquivalentSites/${fiscalYear}`
      );
      dispatch(
        success(types.MEAL_EQUIVALENT_GET_GRID_DATA, { response, fiscalYear })
      );
    } catch (error) {
      const getDataError = {
        Title: 'Error',
        Message: 'An error occured while getting the data. Please try again.',
      };

      dispatch(
        handleErrorException(
          error,
          types.MEAL_EQUIVALENT_SET_ERROR,
          getDataError
        )
      );
    }
    dispatch(loading(types.MEAL_EQUIVALENT_LOADING, false));
  };
};

export const writeChangesToSite = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MEAL_EQUIVALENT_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'SiteMaster/WriteMealEquivalentSites',
        data
      );
      dispatch(setSaveSuccessful(true));
    } catch (error) {
      const writeError = {
        Title: 'Error',
        Message:
          'An error occured while attempting to write the changes. Please try again.',
      };
      dispatch(
        handleErrorException(error, types.MEAL_EQUIVALENT_SET_ERROR, writeError)
      );
    }
    dispatch(loading(types.MEAL_EQUIVALENT_LOADING, false));
  };
};

export const setSaveSuccessful = value => {
  return {
    type: types.MEAL_EQUIVALENT_SET_SUCCESSFUL,
    payload: value,
  };
};

export const checkAll = shouldCheckAll => {
  return {
    type: types.MEAL_EQUIVALENT_GRID_CHECK_ALL,
    payload: shouldCheckAll,
  };
};

export const checkItem = (shouldCheck, row) => {
  return {
    type: types.MEAL_EQUIVALENT_GRID_CHECK_ITEM,
    payload: { shouldCheck, row },
  };
};

export const clearError = () => {
  return {
    type: types.MEAL_EQUIVALENT_CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/state/siteequivalent/actions.js